var _rect, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.5 18C14.5 15.7909 16.2909 14 18.5 14H30.5C32.7091 14 34.5 15.7909 34.5 18V30C34.5 32.2091 32.7091 34 30.5 34H18.5C16.2909 34 14.5 32.2091 14.5 30V18Z",
    fill: "url(#paint0_linear_13711_154126)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 18,
    r: 1,
    fill: "url(#paint1_linear_13711_154126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 29C27.2614 29 29.5 26.7614 29.5 24C29.5 21.2386 27.2614 19 24.5 19C21.7386 19 19.5 21.2386 19.5 24C19.5 26.7614 21.7386 29 24.5 29ZM24.5 27C26.1569 27 27.5 25.6569 27.5 24C27.5 22.3431 26.1569 21 24.5 21C22.8431 21 21.5 22.3431 21.5 24C21.5 25.6569 22.8431 27 24.5 27Z",
    fill: "url(#paint2_linear_13711_154126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13711_154126",
    x1: 19.4231,
    y1: 32.3548,
    x2: 57.608,
    y2: -9.93848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13711_154126",
    x1: 29.9923,
    y1: 18.8355,
    x2: 33.8108,
    y2: 14.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13711_154126",
    x1: 21.9615,
    y1: 28.1774,
    x2: 41.054,
    y2: 7.03076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2e8366cdb51a0be27f33b5fc278137ed.svg";
export { ForwardRef as ReactComponent };